import { render, staticRenderFns } from "./UnsavedModal.vue?vue&type=template&id=274fc467&"
import script from "./UnsavedModal.vue?vue&type=script&lang=js&"
export * from "./UnsavedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports